import { createSelector } from 'reselect'
import { Store } from '../../types'

const customReportConfigSelector = (store: Store) => store.config.customReport

export const customReportGrammarSelector = createSelector(customReportConfigSelector, config => config.grammar)
